import authorizedAPIInstance from '@/api/authorizedAPI';
import { formatAPIError } from '@/utils/helpers';
import type { ProductionLine } from '../utils/types';

export type FacilitiesStatusInput = {
  date: string;
};

export const fetchFacilitiesStatus = async ({
  date,
}: FacilitiesStatusInput): Promise<ProductionLine[]> => {
  try {
    const { data } = await authorizedAPIInstance.get<ProductionLine[]>(
      `/api/facilities/status`,
      {
        params: { date },
      }
    );

    return data;
  } catch (error) {
    throw formatAPIError(error);
  }
};
